export default __webpack_public_path__ + "static/media/account_balance_black_24dp.591af591.svg";